const AUDIO_RETENTION_DAYS = 90;

// 録音データがS3から削除されているか（90日以上経過）を判定する
const isAudioExpired = (registeredAt: Date): boolean => {
  const now = new Date();
  const todayUTC = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  const registeredAtUTC = Date.UTC(
    registeredAt.getUTCFullYear(),
    registeredAt.getUTCMonth(),
    registeredAt.getUTCDate()
  );
  const diffInDays = (todayUTC - registeredAtUTC) / (1000 * 60 * 60 * 24);
  return diffInDays >= AUDIO_RETENTION_DAYS;
};

export default isAudioExpired;
